import React, { CSSProperties } from 'react';
import { makeStyles, Chip, ChipProps, Theme } from '@material-ui/core';
import {
  GraySmall,
  HighSeverityTagBackgroundColor,
  LowSeverityTagBackgroundColor,
  LowSeverityTagTextColor,
  MediumSeverityTagBackgroundColor,
  MediumSeverityTagTextColor,
  NeutralSeverityTagBackgroundColor,
  red,
} from '../../theme/colors';
import { CloseIcon } from '../Icons';
import ColorUtils from '../../utils/ColorUtils';

interface BaseChipProps extends ChipProps {
  severity?: SeverityLevel;
  deleteIconStyle?: CSSProperties;
}

export enum SeverityLevel {
  high = 'high',
  medium = 'medium',
  low = 'low',
  neutral = 'neutral',
}

const useStyles = makeStyles((theme: Theme) => ({
  defaultChip: {
    backgroundColor: ColorUtils.GetColorDarknessShades(
      theme.palette.primary.main,
    ).light,
    color: theme.palette.primary.main,
  },
  high: {
    background: HighSeverityTagBackgroundColor,
    color: red,
  },
  medium: {
    background: MediumSeverityTagBackgroundColor,
    color: MediumSeverityTagTextColor,
  },
  low: {
    background: LowSeverityTagBackgroundColor,
    color: LowSeverityTagTextColor,
  },
  neutral: {
    background: NeutralSeverityTagBackgroundColor,
    color: GraySmall,
  },
  closeIcon: {
    backgroundColor: ColorUtils.GetColorDarknessShades(
      theme.palette.primary.main,
    ).light,
    borderRadius: theme.shape.borderRadius,
    padding: '3px',
    height: 6,
    width: 6,
    color: theme.palette.primary.main,
    marginLeft: '5px',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

export const BaseChip: React.FC<BaseChipProps> = ({
  severity,
  deleteIconStyle,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Chip
      classes={{ root: classes.defaultChip, deleteIcon: classes.closeIcon }}
      deleteIcon={<CloseIcon style={deleteIconStyle || {}} />}
      className={`${severity ? classes[severity] : classes.defaultChip}`}
      {...rest}
    />
  );
};
